import { createDraftSafeSelector as createSelector } from '@reduxjs/toolkit';

import { Inject } from '@vk-hr-tek/core/ioc';

import { NotificationsMapper } from '../mappers';

import {
  bellNotificationsAdapter,
  BellNotificationsWithRootState as RootState,
} from './bellNotifications.state';

export const selectListNotificationsStatus = (state: RootState) =>
  state.bellNotifications.page.status;

export const selectListNotificationsError = (state: RootState) =>
  state.bellNotifications.page.error;

export const selectUnreadNotificationsCount = (state: RootState) =>
  state.bellNotifications.page.unreadNotificationsCount;

export const selectIsGetUnreadNotificationsCounterPending = (
  state: RootState,
) => state.bellNotifications.page.isGetUnreadNotificationsCounterPending;

export const selectListNotificationsWithDateGroups = createSelector(
  [
    bellNotificationsAdapter.getSelectors(
      (state: RootState) => state.bellNotifications.page,
    ).selectAll,
    (_: RootState, inject: Inject) => inject(NotificationsMapper),
  ],
  (notifications, format) =>
    format.processEntityListWithDateGroups(notifications),
);

export const selectIsMarkReadAllPending = (state: RootState) =>
  state.bellNotifications.page.isMarkReadAllPending;

export const selectCurrentLastNotificationId = (state: RootState) =>
  state.bellNotifications.page.currentLastNotificationId;

export const selectHasMoreNotifications = (state: RootState) =>
  state.bellNotifications.page.hasMoreNotifications;

export const selectBellNotificationsStatus = (state: RootState) =>
  state.bellNotifications.bell.status;

export const selectBellNotificationsError = (state: RootState) =>
  state.bellNotifications.bell.error;

export const selectBellCounter = (state: RootState) =>
  state.bellNotifications.bell.unreadNotificationsCount;

export const selectBellNotificationsWithDateGroups = createSelector(
  [
    bellNotificationsAdapter.getSelectors(
      (state: RootState) => state.bellNotifications.bell,
    ).selectAll,
    (_: RootState, inject: Inject) => inject(NotificationsMapper),
  ],
  (notifications, format) =>
    format.processEntityListWithDateGroups(notifications),
);

export const selectIsBellMarkReadAllPending = (state: RootState) =>
  state.bellNotifications.bell.isMarkReadAllPending;

export const selectBellCurrentLastNotificationId = (state: RootState) =>
  state.bellNotifications.bell.currentLastNotificationId;

export const selectHasBellMoreNotifications = (state: RootState) =>
  state.bellNotifications.bell.hasMoreNotifications;
